import React from 'react';
import './DashboardControls.css';

function DashboardControls({ 
  searchTerm, 
  setSearchTerm, 
  selectedLocation, 
  setSelectedLocation, 
  locations, 
  onExport, 
  onClearFilters, 
  filteredEmployeesCount 
}) {
  return (
    <div className="dashboard-controls">
      <div className="search-section">
        <input
          type="text"
          placeholder="Search by ID or Name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div>
      
      <div className="filter-section">
        <select
          value={selectedLocation}
          onChange={(e) => setSelectedLocation(e.target.value)}
          className="filter-select"
        >
          <option value="">All Locations</option>
          {locations.map(location => (
            <option key={location} value={location}>
              {location}
            </option>
          ))}
        </select>
      </div>

      <div className="action-buttons">
        <button 
          onClick={onExport} 
          className="export-excel-button"
          disabled={filteredEmployeesCount === 0}
          title={filteredEmployeesCount === 0 ? "No data to export" : `Export ${filteredEmployeesCount} records to Excel`}
        >
          Export
        </button>
        
        {(searchTerm || selectedLocation) && (
          <button onClick={onClearFilters} className="clear-filters-button">
            Clear Filters
          </button>
        )}
      </div>
    </div>
  );
}

export default DashboardControls;
